import { VisitDialogContext } from "./DialogContext";
import Modal from "../../../../components/portal/Modal";
import "./Header";
import "./ContentWrapper";
import "./VisitDetails";
import "./VisitPictures";
import "./VisitRemark";
import "./VisitSigns";
import "./VisitFooter";
import "./VisitDownloads";

export function VisitModalLayout ({children, value}) {
  return (
    <VisitDialogContext.Provider value={value}>
      <Modal
        onClose={
          value.successView || value.isReportPdfLoaded || value.isImagePdfLoaded
            ? undefined
            : value.closeDialog
        }
        modalWidth="view-dialog-content"
        closeIcon={!value.successView}
      >{children}</Modal>
    </VisitDialogContext.Provider>
  );
};
